export default "__VITE_ASSET__tLk8mIRt__"